import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { URL_IMAGES_BANKS } from 'constants/UrlConstants';

class AnimatedBanks extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 5,
            maxIndex: null,
            currentBatch: [0, 1, 2, 3, 4],
        };
    }

    full_time = 6000;
    timerId = null;

    componentDidMount() {
        const quantityBanks = this.props.data.banksInfo.length;
        const maxIndex = quantityBanks - 1;
        this.setState((state) => {
            return {
                ...state,
                maxIndex,
            };
        });
        this.timerId = setInterval(() => {
            let newCurrentBatch = [];
            let cursor = this.state.currentBatch[this.state.currentBatch.length - 1] + 1;
            for (let currentStep = 1; currentStep <= this.state.step; currentStep++, cursor++) {
                if (cursor > this.state.maxIndex) {
                    cursor = 0;
                }
                newCurrentBatch.push(cursor);
            }
            this.setState((state) => {
                return {
                    ...state,
                    currentBatch: newCurrentBatch,
                };
            });
        }, this.full_time);
    }

    componentWillUnmount() {
        clearInterval(this.timerId);
    }

    arrayBanks = () => {
        const { banks, banksInfo } = this.props.data;
        return this.state.currentBatch.map((number, index) => {
            return (
                <li key={`${banks[number]}${index}`}>
                    <figure className="animatedBanks">
                        <img height="64" width="64" alt={banks[number]} src={`${URL_IMAGES_BANKS}/${banksInfo[number].logo}`} />
                        <figcaption className="smallcopy color-medium-gray">{banksInfo[number].name}</figcaption>
                    </figure>
                </li>
            );
        });
    };

    render() {
        return (
            <ul className="bank-logos animated">
                {this.arrayBanks()}
                <li className="spinner">
                    <figure>
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64" className="svg-icon-spinner">
                            <g fill="none" strokeWidth="2" strokeLinecap="round">
                                <circle cx="32" cy="32" r="11" stroke="#d7dee0"></circle>
                                <circle cx="32" cy="32" r="11" stroke="#9da1a3" strokeDasharray="75.36" className="animated"></circle>
                            </g>
                        </svg>
                        <figcaption className="smallcopy color-medium-gray">{this.props.manyMore}</figcaption>
                    </figure>
                </li>
            </ul>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        manyMore: state.messages.pageMessages.manyMore,
    };
};
AnimatedBanks.propTypes = {
    data: PropTypes.shape({
        banks: PropTypes.arrayOf(PropTypes.string),
        header: PropTypes.string,
        title: PropTypes.string,
        banksInfo: PropTypes.array,
    }),
    manyMore: PropTypes.string,
};

export default connect(mapStateToProps)(AnimatedBanks);
